export const isFetching = (state: any) => state.isFetching;

export const allUsers = (state: any) => state.allUsers;

export const deactivatedUsers = (state: any) => state.deactivatedUsers;
